import { DbFolder, DbID } from '~src/types/db';
import { getParentsIds } from './tree';

export const getPath = (
  folders: DbFolder[] | undefined,
  parentId: DbID | null
) => {
  if (folders) {
    const parentIds = getParentsIds(folders, String(parentId));
    parentIds.push(String(parentId));

    const parentLocation = parentIds
      .map((id) => {
        const dbFolder = folders?.find((v) => String(v.id) === id);
        if (!dbFolder) return undefined;

        return dbFolder.name || 'Unknown';
      })
      .filter(Boolean) as string[];

    let path = '';
    parentLocation.forEach((element) => (path += `/${element}`));

    return path || '/';
  }
  return '';
};
